import Enum from "../../../enum";
import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

export const baseSchema = {
    "document": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "form": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "serverForm": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentStatus",
            value: Enum.BE_DOCUMENT_STATUS.WAIT,
        },
        "convertStatus": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentConvertStatus",
            value: Enum.BE_DOCUMENT_CONVERT_STATUS.NONE,
        },
        "documentDraftId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentTemplateId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        // Embedded: attribute
        "attribute.imported": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.autoCompleted": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.enabledInterPageSeal": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.enabledViewPassword": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.viewPassword": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "attribute.viewPasswordHint": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "attribute.enabledViewPasswordOnComplete": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.enabledApproverFullApproval": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.enabledExternalDocument": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.externalDocumentReason": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "attribute.enabledManualSealDate": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "attribute.manualSealDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        // Embedded: statusDate
        "statusDate.startedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "statusDate.requestedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "statusDate.completedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "statusDate.revokedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "statusDate.deletedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "statusDate.sealedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "statusDate.convertStartedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "statusDate.convertEndedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    },

} as const;
